import React, { Component, Fragment, useState, useEffect, useRef } from 'react';
import QuantitySelector from '../QuantitySelector';
import ProductPrice from '../ProductPrice';
import Checkbox from '../Checkbox';
import BuyBox from './BuyBox';
import { translate } from '../../Services/translation';
import LightboxImagesAccessories from '../LightboxImagesAccessories';
import { pushAddToCartEvent } from "../../Actions/Gtm.action";
import { culture } from '../../Services/culture';
import { currency } from '../../Services/currency';
import { useDispatch } from 'react-redux';
import { load as loadCart, hint as hintCart, update } from '../../Actions/Cart.action';

const BuySection = (props) => {
    const dispatch = useDispatch();
    let superBuilderHasData = props.superBuilder != null && props.superBuilder != "";
    let superBuilder = superBuilderHasData ? JSON.parse(props.superBuilder) : null;
    let superBuilderHasSections = superBuilderHasData ? JSON.parse(props.superBuilder).sections.length > 0 : false;
    let unitPrice = props.campaignPrice > 0 ? props.campaignPrice : props.price;

    const [anyAccessorySelected, setanyAccessorySelected] = useState(false);
    const [quantity, setquantity] = useState(props.packagingQuantity);
    const [activeAccessory, setactiveAccessory] = useState(null);
    const [originalPrice, setoriginalPrice] = useState(superBuilderHasSections ? 0 : props.price);
    const [unitPriceData, setunitPriceData] = useState(superBuilderHasSections ? 0 : unitPrice);
    const [packagingQuantity, setpackagingQuantity] = useState(props.packagingQuantity);
    const [accessoryList, setaccessoryList] = useState([]);
    const [updateState, setupdateState] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const formatter = new Intl.NumberFormat(culture, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    });


    const totalAccessoriesPrice = accessoryList.reduce((sum, accessory) => {
        if (accessory.active) {
            return sum + (accessory.price * accessory.quantity);
        }
        return sum;
    }, 0);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (isOpen && dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    useEffect(() => {
        stickyBuyboxObserver();
        setaccessoryList(getAccessoryList(props.accessories));
    }, []);

    useEffect(() => {
        let superBuilderPrices = superBuilderHasSections ? getSuperBuilderStandardPriceTotal(props) : null;

        let price = superBuilderHasSections ? superBuilderPrices.price : props.price;
        let campaignPrice = superBuilderHasSections ? superBuilderPrices.campaignPrice : props.campaignPrice;

        setaccessoryList(getAccessoryList(props.accessories));
        setoriginalPrice(price);
        setunitPriceData(campaignPrice > 0 ? campaignPrice : price);
        setpackagingQuantity(props.packagingQuantity);
    }, [props]);


    const getSuperBuilderStandardPriceTotal = (props) => {
        var total = {
            price: 0,
            campaignPrice: 0
        };

        var superBuilder = JSON.parse(props.superBuilder);
        superBuilder.sections.forEach(s => s.variants.forEach((v) => {
            superBuilder.selectedCombinedKeys.filter(keys => {
                if (v.key == keys.key) {
                    total.price += v.price * keys.quantity;
                    total.campaignPrice += v.campaignPrice * keys.quantity;
                }
            });
        }));

        return total;
    }

    const updateQuantity = (articleNumber, adjust) => {
        let newQuantity = quantity + adjust;

        if (newQuantity < 1) {
            newQuantity = packagingQuantity;
        }
        
        setquantity(newQuantity);
        if (adjust < 0) {
            dispatch(update([articleNumber], quantity + adjust))
        } else {            
            buy(adjust);
        }        
    }

    const onAccessoryClick = (item) => {
        setactiveAccessory(item);
    }


    const stickyBuyboxObserver = () => {
        if (!!window.IntersectionObserver) {
            let observer = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    var buyContainer = document.getElementsByClassName("buy-box__main");
                    if (buyContainer.length) {
                        if (entry.boundingClientRect.bottom < entry.rootBounds.bottom) {
                            buyContainer[0].classList.add("anim-hide");
                        } else {
                            buyContainer[0].classList.remove("anim-hide");
                        }
                    }
                });
            }, {
                rootMargin: "100% 0px 0px 0px",
                threshold: 1
            }
            );
            document.querySelectorAll('.js-product-info').forEach(item => { observer.observe(item) });
        }
    }

    const buy = (quantityCalculated) => {        
        if (superBuilderHasSections) {
            buySuperBuilder();
            return;
        }
        addArticles(props.article, quantityCalculated > 0 ? quantityCalculated : quantity);        
    }

    const buySuperBuilder = () => {
        let order = {
            parentid: props.parent,
            articles: [],
            rowItems: [],
            isSuperBuilder: true
        }
        var superBuilder = JSON.parse(superBuilder);
        let selectedCombinedKeys = superBuilder.selectedCombinedKeys;
        for (var i = 0; i < selectedCombinedKeys.length; i++) {
            order.articles.push({
                articleNumber: getArticleNumber(superBuilder, selectedCombinedKeys[i].key),
                quantity: selectedCombinedKeys[i].quantity * quantity,
                isAccessory: false,
                superBuilderKey: selectedCombinedKeys[i].key,
                isMandatory: selectedCombinedKeys[i].isMandatory,
                isMaximumOfOneAllowed: selectedCombinedKeys[i].isMaximumOfOneAllowed
            });
        }

        // Add to cart
        fetch("/api/cart/addconfiguredarticle", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'litium-request-context': JSON.stringify(__litium.requestContext)
            },
            body: JSON.stringify(order),
            redirect: 'follow'
        })
            .then(response => response.json())
            .then(result => {
                dispatch(loadCart(result));
                if (order.articles[0]) {
                    dispatch(hintCart(true, items[0].article));
                    setTimeout(() => {
                        dispatch(hintCart(false, items[0].article))
                    }, 2000);
                    dispatch(pushAddToCartEvent(order.articles, false));                    
                }
            })
            .catch(error => console.log('error', error));
    }

    const getArticleNumber = (superBuilder, key) => {
        var articleNumber = "";
        superBuilder.sections.forEach(s => s.variants.forEach(v => {
            if (v.key == key) {
                articleNumber = v.articleNumber;
            }
        }))

        return articleNumber;
    }

    const getTotalPrice = (useFullPrices, packagingQuantity) => {
        let price = (useFullPrices ? originalPrice : unitPriceData) * (quantity > 0 ? quantity : 1);

        accessoryList.forEach(accessory => {
            let accessoryPrice = useFullPrices ? accessory.originalPrice : accessory.price;

            if (accessory.active) {
                price += (accessoryPrice * accessory.quantity);
            }
        });

        return price;
    }
    const addArticles = (articleNumber, newQuantity) => {
        let items = [{
            article: articleNumber,
            quantity: newQuantity
        }];

        accessoryList.forEach(accessory => {
            if (accessory.active) {
                items.push({
                    Article: accessory.id,
                    Quantity: accessory.quantity
                })
            }
        });

        fetch('/api/cart/addarticles', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'litium-request-context': JSON.stringify(__litium.requestContext)
            },
            body: JSON.stringify(items),
            redirect: 'follow'
        })
            .then(response => response.json())
            .then(result => {
                dispatch(loadCart(result));
                if (items[0]) {
                    setTimeout(() => {
                        dispatch(hintCart(items[0].article));
                    }, 2000);                    
                    dispatch(pushAddToCartEvent(items, true));
                }
            })
            .catch(error => console.log('error', error));
    }

    const updateAccessoryQuantity = (articleNumber, quantityChange) => {
        accessoryList.forEach(accessory => {
            if (accessory.id === articleNumber) {
                let newQuantity = accessory.quantity += quantityChange;

                if (newQuantity < 0) {
                    newQuantity = 0;
                }

                accessory.active = (newQuantity > 0);
                accessory.quantity = newQuantity;
                
                // if (quantityChange < 0) {
                //     dispatch(update([articleNumber], accessory.quantity + quantityChange));
                // } else {
                //     addArticles(articleNumber, quantityChange);
                // }

                setanyAccessorySelected(accessoryList.some(a => a.active)); 
                setupdateState(!updateState);              
            }
        });
    }

    const toggleAccessory = (articleNumber, isChecked) => {
        accessoryList.forEach(accessory => {
            if (accessory.id === articleNumber) {
                accessory.active = isChecked;

                if (accessory.active && accessory.quantity === 0) {
                    accessory.quantity = 1;
                }

                setanyAccessorySelected(accessoryList.some(a => a.active));    
                setupdateState(!updateState);            
            }
        });
    }

    const getAccessoryList = (accessoryData) => {
        let list = [];

        accessoryData.forEach(accessory => {
            list.push({
                id: accessory.id,
                name: accessory.name,
                imageData: accessory.imageData,
                price: (accessory.decimalCampaignPrice && accessory.decimalCampaignPrice < accessory.decimalPrice) ? accessory.decimalCampaignPrice : accessory.decimalPrice,
                originalPrice: accessory.decimalPrice,
                quantity: 0,
                active: false,
                packagingQuantity: accessory.packagingQuantity
            });
        });

        return list;
    }

    return (
        <Fragment>
            {props.bundleProducts.length > 0 &&
                <ul className="product-selector bundle-container">
                    <li>
                        <div className="product-selector__header">
                            <div className='section-status'>
                            </div>
                            <div className="product-selector__name summary">
                                <span className="bold">{translate('bundleproducts.header')}</span>
                            </div>
                        </div>
                        <div className="product-selector__content bundle-section">
                            <div className="product-selector__selected-options">
                                <ul className="product-selector__selected-options-list">
                                    {props.bundleProducts.map((bundleproduct, index) => {
                                        return <li key={index} className="product-selector__selected-option">
                                            <a href={bundleproduct.url}>{bundleproduct.quantity} x {bundleproduct.name}</a>
                                        </li>
                                    })}
                                </ul>
                            </div>
                        </div>
                    </li>
                </ul>
            }
            {accessoryList.length > 0 &&
                <Fragment>
                    <div className="product-selector__name">
                        <span className="bold">{translate('accessories.header')}</span>
                    </div>
                    <ul ref={dropdownRef} className="product-selector accessory-selector">
                        <li className={`product-selector__item ${isOpen ? 'is-open' : ''}`}>
                            <div 
                                className="product-selector__header" 
                                onClick={() => setIsOpen(!isOpen)}
                            >
                                <div className={'section-status' + (anyAccessorySelected ? ' section-status--done' : '')}>
                                    {anyAccessorySelected &&
                                        <svg>
                                            <use href="/ui/images/tibergs-svg/sprite/sprite.svg#checked"></use>
                                        </svg>
                                    }
                                </div>
                                <div className="product-selector__name">
                                    {totalAccessoriesPrice > 0 ? 
                                        <span>{translate('accessories.added')}</span>
                                        : 
                                        <span>{props.title}</span>
                                    }
                                    {totalAccessoriesPrice > 0 && (
                                        <span className="accessory-total-price">
                                            {` + ${formatter.format(totalAccessoriesPrice)}`}
                                        </span>
                                    )}
                                </div>
                                <span className={`dropdown-arrow ${isOpen ? 'arrow-up' : 'arrow-down'}`}>
                                    <svg className="svg-arrow"><use href="/ui/images/tibergs-svg/sprite/sprite.svg#arrow-right"></use></svg>
                                </span>
                            </div>
                            {isOpen && (
                                <div className="product-selector__content">
                                    <ul className="accessory-list product-page">
                                        {accessoryList.map((accessory, index) => {
                                            return <li key={`accessory-${accessory.id}-${index}`}>
                                                <QuantitySelector isSmall={true} quantity={accessory.quantity} articleNumber={accessory.id} 
                                                packagingQuantity={accessory.packagingQuantity} 
                                                    onChange={updateAccessoryQuantity}></QuantitySelector>
                                                <div className={'image-container contain' + (accessory.img ? '' : ' dummy-image')}>
                                                    {accessory && accessory.imageData && accessory.imageData.src && <a data-src={accessory.imageData.src} itemProp="url" className="product-image" onClick={() => onAccessoryClick(accessory.imageData)}>                               
                                                        <img className="product-detail__image--main" itemProp="image" src={accessory.imageData.thumbnail} 
                                                        alt={accessory.imageData.alt}/>
                                                    </a>
                                                    }
                                                </div>
                                                <div className="accessory-list__content">
                                                    <div className="accessory-list__name">
                                                        <span>{accessory.name}</span>
                                                    </div>
                                                    <ProductPrice
                                                        formatter={formatter}
                                                        campaignPrice={accessory.price}
                                                        price={accessory.originalPrice}
                                                        packagingQuantity={accessory.packagingQuantity}
                                                        quantity={accessory.quantity}
                                                    ></ProductPrice>
                                                </div>
                                            </li>
                                        })}
                                    </ul>
                                </div>
                            )}
                        </li>
                    </ul>
                </Fragment>
            }
            {activeAccessory &&
                <LightboxImagesAccessories images={activeAccessory} onClick={onAccessoryClick} />
            }
            <BuyBox buy={buy}
                totalPrice={getTotalPrice(false, packagingQuantity)}
                quantity={quantity}
                articleNumber={props.article}
                currentPrice={unitPriceData}
                originalPrice={getTotalPrice(true, packagingQuantity)}
                updateQuantity={updateQuantity}
                comment={props.comment}
                stockInfoMessage={props.stockInfoMessage}
                stockstatus={props.stockstatus}
                formatter={formatter}
                enabled={true}
                packagingQuantity={packagingQuantity}
                productInfoMessage={props.productInfoMessage}
                featureList={props.featureList}
                lowestPrice30Days={props.lowestPrice30Days}
                campaignRemainingDays={props.campaignRemainingDays}
                campaignRemainingDaysDesc={props.campaignRemainingDaysDesc}
                variantSystemId={props.variantSystemId}
                key={props.key}
                ></BuyBox>
        </Fragment>);
}

export default BuySection;